import { render, staticRenderFns } from "./SelectStudents.vue?vue&type=template&id=c6662184&scoped=true&lang=true&"
import script from "./SelectStudents.vue?vue&type=script&lang=js&"
export * from "./SelectStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6662184",
  null
  
)

export default component.exports